import logo from "./logo.svg";
import "./App.css";
import Layouts from "./layouts/layouts";
import Footer from "./layouts/footer";
import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { AdminRouteq } from "./route/index";
import Chatbot from "./components/Chatbot";
function App() {
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");
  const hideChatbotRoutes = ["/login", "/register", "/forgot-password"];

  const shouldShowChatbot =
    userRole === "superadmin" && !hideChatbotRoutes.includes(location.pathname);

  return (
    <>
      {/* <Layouts /> */}
      <AdminRouteq />
      {/* <Chatbot /> */}
      {shouldShowChatbot && <Chatbot />}

      {/* <Footer /> */}
    </>
  );
}

export default App;
